import { render, staticRenderFns } from "./request-previous.vue?vue&type=template&id=7131b65e&scoped=true"
import script from "./request-previous.vue?vue&type=script&lang=js"
export * from "./request-previous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7131b65e",
  null
  
)

export default component.exports